/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { ArrowLeftOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Modal, Row, Typography } from 'antd';
import ModalConfirmationControls from './ModalConfirmationControls';

const { Text } = Typography;

const ModalConfirmPrenomina = ({
  onConfirm,
  onCancel,
  cierre,
  loading,
  open,
}) => {
  if (cierre) {
    return (
      <Modal
        title={(
          <Row justify="space-between">
            <Text>
              Cerrar Pre-Nómina
            </Text>
            <ModalConfirmationControls
              onFinish={onConfirm}
              onFinishText="Continuar"
              onFinishIcon={<CheckCircleOutlined />}
              onCancel={onCancel}
              onCancelIcon={<ArrowLeftOutlined />}
              loading={loading}
            />
          </Row>
        )}
        className="modal-delete"
        open={open}
        footer={null}
        closable={false}
        maskClosable={!loading}
        keyboard={!loading}
        destroyOnClose
        width="40%"
      >
        <Text style={{ fontSize: 16 }}>
          ¿Desea Cerrar la Pre-Nómina a los Tipos de Nóminas Empleados seleccionados?
        </Text>
        <Text>
          Esta acción provocará que no se puedan hacer modificaciones a Empleados, Descuentos, Incidencias y Plazas con esos tipos de Nómina Empleados.
        </Text>
      </Modal>
    );
  }
  return (
    <Modal
      title={(
        <Row justify="space-between">
          <Text>
            Habilitar Pre-Nómina
          </Text>
          <ModalConfirmationControls
            onFinish={onConfirm}
            onFinishText="Continuar"
            onFinishIcon={<CheckCircleOutlined />}
            onCancel={onCancel}
            onCancelIcon={<ArrowLeftOutlined />}
            loading={loading}
          />
        </Row>
      )}
      className="modal-delete"
      open={open}
      footer={null}
      closable={false}
      maskClosable={!loading}
      keyboard={!loading}
      destroyOnClose
      width="40%"
    >
      <Text style={{ fontSize: 16 }}>
        ¿Desea Habilitar la Pre-Nómina a los Tipos de Nóminas Empleados seleccionados?
      </Text>
      <Text>
        Esta acción provocará que se puedan hacer modificaciones a Empleados, Descuentos, Incidencias y Plazas con esos tipos de Nómina Empleados.
      </Text>
    </Modal>
  );
};

ModalConfirmPrenomina.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  cierre: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  open: PropTypes.bool,
};

ModalConfirmPrenomina.defaultProps = {
  loading: false,
  open: false,
};

export default ModalConfirmPrenomina;
